import React, { useMemo } from "react";
import styles from "./style.module.less";
import { goToNativePage, goToPageV2, NativeByUrlList } from "@/utils/common";
import { trackGdp } from "@/utils/gio-report";
import { getChannel, goToPage } from "@/utils/tools";
import { Toast } from "@xp-design/mobile";
import { renderStyle } from "@/pages/par-marketing/configPage/utils";
import { useConfigPage } from "@/hooks/useConfigPage/useConfigPage";
import { useLockFn } from "ahooks";
import { useState } from "react";
import { ActivityInfo, Module, PageDataConfig } from "@/types/config-page";
import { processOssImage } from "@/utils/image";

interface TaskListProps {
  actInfo: any;
  pageInfo: PageDataConfig;
  activityStatusList: Record<number, string>;
  activityInfo: ActivityInfo;
  pageModuleDto: Module[];
  pageVersionDto: PageDataConfig;
}

const TaskList: React.FC<TaskListProps> = ({
  actInfo,
  pageInfo,
  activityStatusList,
  activityInfo,
  pageModuleDto,
  pageVersionDto,
}) => {
  // lotteryActivityTaskDtos：这个活动配置的任务
  const { lotteryActivityTaskDtos = [] } = actInfo;
  const [prizeMaskShow, setPrizeMaskShow] = useState(false);

  // 从context获取分享路径
  const { handleShare } = useConfigPage();

  // 任务code列表
  const taskCodeList = lotteryActivityTaskDtos.map((item) => item.taskCode);

  // 文案风格样式列表
  const styleList =
    pageInfo?.visual?.prizeSetting?.[3]?.content?.[0]?.options?.map?.(
      (item) => {
        item.styleObject = renderStyle(item.styleData); // 生成style对象
        return item;
      },
    );

  const contentBgImg = useMemo(
    () => (pageInfo?.visual?.prizeSetting[0]?.content[8]?.val || ""),
    [pageInfo],
  );
  console.log("contentBgImg", contentBgImg);

  // 拉起分享
  const share = async () => {
    trackGdp("P20189", "B002", {
      trackName: "充电_营销专题页_页面分享",
      origin: getChannel(),
      userType: "",
      versionId: pageModuleDto[0].versionCode,
      pageId: pageModuleDto[0].pageCode,
    });

    if (handleShare) {
      handleShare(pageVersionDto);
    }
  };

  // 点击任务按钮
  const goTask = useLockFn(async (portalTaskItem, actTaskItem) => {
    console.log("taskItem=>>,", portalTaskItem, actTaskItem);
    setPrizeMaskShow(true);
    setContentOverflow(true);
    try {
      await trackGdp("P20189", "B004", {
        trackName: "充电_营销专题页_组件点击",
        origin: getChannel(),
        userType: "",
        versionId: activityInfo.versionCode,
        pageId: activityInfo.pageCode,
        ComponentCode: activityInfo.moduleId,
        type: activityInfo.moduleType,
        activityId: activityInfo.connectedActivitiesId,
        comp_style: JSON.parse(activityInfo.moduleJson).visual?.visualData[0]
          ?.typeName,
        status:
          activityStatusList[actInfo?.lotteryActivityDto?.activityStatus] || "",
        clickLocation:
          actTaskItem.taskType == "4" ? "去邀请按钮" : "去完成按钮",
        taskid: portalTaskItem.taskCode,
        tabName: portalTaskItem.tabName,
      });
      // 任务类型 1免费赠送 2充电订单 3充电度数 4分享
      console.log("任务类型->>>", actTaskItem.taskType, actTaskItem);
      if (actTaskItem.matchFlag) {
        if (actTaskItem.isEnd) {
          return Toast.show({
            content: "该任务已结束，请完成其他任务获得抽奖机会吧",
          });
        }
        if (!actTaskItem.isBegin) {
          return Toast.show({
            content: "该任务暂未开始，请完成其他任务获得抽奖机会吧",
          });
        }
      } else {
        return Toast.show({
          content: "您暂不符合参与条件，请点击活动详情查看参与条件",
        });
      }
      if (!["3-2", "0"].includes(actInfo.lotteryActivityDto.activityStatus)) {
        return;
      }
      const channel: string = getChannel();

      // 优先走分享
      if (Number(actTaskItem.taskType) === 4) {
        share();
        return
      }

      // 浏览器会优先跳一下APP，在APP里再进行分享
      if (["iosBrowser", "browser"].includes(channel)) {
        // 在普通浏览器中
        const jumpObj = portalTaskItem?.content?.[3] || {};
        if (jumpObj?.jumpUrlMap) {
          NativeByUrlList(jumpObj.jumpUrlMap);
          return;
        }
        let jumpUrl = "";
        console.log("jumpObj.fixedHref", jumpObj);
        if (jumpObj.val === "1") {
          jumpUrl = jumpObj.fixedHref[jumpObj.selectVal || 0]; // 没填默认第一个
          const jumpUrlArr = jumpUrl?.split(",") || [];
          if (jumpUrlArr[1]) {
            const url = `https://app.xiaopeng.com/activity/openurl?url=${jumpUrlArr[1] ? encodeURIComponent(jumpUrlArr[1]) : ""}`;
            goToPage(url);
          }
        } else {
          if (jumpObj.inputVal && jumpObj.inputVal.indexOf("http") == 0) {
            // 配置了h5 链接
            window.location.href = jumpObj.inputVal;
          }
          if (jumpObj.inputVal && jumpObj.inputVal.indexOf("xiaopeng:") == 0) {
            // 配置app 地址
            
            const url = `https://app.xiaopeng.com/activity/openurl?url=${encodeURIComponent(jumpObj.inputVal)}`;
            goToPage(url);
          }
        }
        return;
      }
      
      // 其他任务的跳转跳转
      if (Number(actTaskItem.taskType) !== 4) {
        const jumpObj = portalTaskItem?.content?.[3] || {};
        if (jumpObj?.jumpUrlMap) {
          NativeByUrlList(jumpObj.jumpUrlMap);
          await new Promise((resolve) => {
            setTimeout(() => {
              resolve(1);
            }, 300);
          });
          return;
        }
        let jumpUrl = "";
        if (jumpObj.val === "1") {
          jumpUrl = jumpObj.fixedHref[jumpObj.selectVal || 0]; // 没填默认第一个
          const jumpUrlArr = jumpUrl?.split(",") || [];
          goToNativePage({
            mini: jumpUrlArr[0],
            app: jumpUrlArr[1],
          });
        } else {
          jumpUrl = jumpObj.inputVal;
          goToPageV2({ url: jumpUrl });
        }
        await new Promise((resolve) => {
          setTimeout(() => {
            resolve(1);
          }, 300);
        });
      }
    } catch (e) {
      console.log("跳转异常", e);
    } finally {
      setTimeout(() => {
        setPrizeMaskShow(false);
        setContentOverflow(false);
      }, 1000);
    }
  });
  const setContentOverflow = (hidden: boolean) => {
    document.body.style.overflow = hidden ? "hidden" : "auto";
    document.body.style.pointerEvents = hidden ? "none" : "";
    const configPage = document.getElementById("configPage");
    if (configPage) {
      configPage.style.overflow = hidden ? "hidden" : "auto";
    }
  };

  if (!lotteryActivityTaskDtos || !lotteryActivityTaskDtos.length) return null;

  return (
    <>
      <div
        className={styles.taskList}
        style={{
          backgroundImage: `url(${processOssImage(contentBgImg)})`,
          backgroundSize: "100% 100%",
        }}
      >
        {/* 任务列表标题 */}
        <div className={styles.taskListTitle} style={styleList[2]?.styleObject}>
          做任务得抽奖机会
        </div>
        {/* 分割线 */}
        <div className={styles.line} />
        {/* 每个任务渲染 */}
        {pageInfo?.prizeTasks?.taskSetting.map((item, index) => {
          // portal启用的任务 && 活动内启用的任务
          if (
            item.content[0].val === "1" &&
            taskCodeList.includes(item.taskCode)
          ) {
            const actTaskItem =
              lotteryActivityTaskDtos.find(
                (e) => e.taskCode === item.taskCode,
              ) || {};
            return (
              <div className={styles.taskItem} key={`taskItem${index}`}>
                {/* 任务图标 */}
                <img src={processOssImage(item.content[4].val)} alt={`Task Icon ${index}`} />
                <div>
                  <div className={styles.taskInfo}>
                    <div
                      className={styles.taskName}
                      style={styleList[3]?.styleObject}
                    >
                      {item.content[1].val}{" "}
                      <span style={{ wordBreak: "break-word" }}>
                        （{actTaskItem.finishTimes || "0"}
                        {actTaskItem.taskMaxTimes === null
                          ? ""
                          : `/${actTaskItem.taskMaxTimes}`}
                        ）
                      </span>
                    </div>
                    <div
                      className={styles.taskDesc}
                      style={styleList[4]?.styleObject}
                    >
                      {item.content[2].val}
                    </div>
                  </div>
                  <div
                    className={styles.taskBtn}
                    onClick={() => {
                      goTask(item, actTaskItem);
                    }}
                    style={{
                      backgroundImage: `url(${processOssImage(item.content[5].val)})`,
                      backgroundSize: "100% 100%",
                    }}
                  ></div>
                </div>
              </div>
            );
          }
          return null;
        })}
      </div>
      {prizeMaskShow && <div className={styles.prizeMask}></div>}
    </>
  );
};

export default TaskList;
